import { render, staticRenderFns } from "./TalksTopics.vue?vue&type=template&id=11280030&"
import script from "./TalksTopics.vue?vue&type=script&lang=js&"
export * from "./TalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports